import Block from './block';
import { BlockPropsBase } from '../../props';
import { BlockType } from '../../block-type';
import { flattenChildren } from '../..';

let description: typeof import('./description').default;
let getProps: typeof import('./getProps').default;

if (process.env.TARGET == 'admin' || process.env.BROWSER != 'true') {
	description = require('./description').default;
}
if (process.env.BROWSER != 'true') {
	getProps = require('./getProps').default;
}

const ArticleHeader: BlockType = {
	component: Block,
	getChildren(props: BlockPropsBase): BlockPropsBase[] {
		return flattenChildren(props.content);
	},
	description,
	section: 'Article',
	info: {
		requiresParent: null,
		requiresAncestor: [ 'article/root' ],
		permittedChildren: [],
		forbiddenAncestor: [],
		forbiddenDescendant: []
	},
	getProps,
	cacheRequiresRecord: () => false
};

export default ArticleHeader;

